export enum ConditionBooleanOperators {
  and = 'ALL',
  or = 'ANY'
}
export enum ConditionOperators {
  equal = 'EQUAL',
  notEqual = 'NOT_EQUAL',
  contains = 'CONTAINS',
  greater = 'GREATER',
  lesser = 'LESSER',
  isSet = 'IS_SET',
  isUnset = 'IS_UNSET',
  anyOf = 'ANY_OF',
  notAnyOf = 'NOT_ANY_OF'
}

export enum ConditionDirectiveKeys {
  show = 'SHOW',
  hide = 'HIDE',
  showSpecific = 'SHOW_SPECIFIC',
  hideSpecific = 'HIDE_SPECIFIC',
  enable = 'ENABLE',
  disable = 'DISABLE'
}
export type ConditionField = {
  fieldId: string
  operator: ConditionOperators
  values: Array<string | number | boolean>
}
export type ConditionSet = {
  booleanOperator: ConditionBooleanOperators
  conditions: ConditionField[]
}
export type ConditionDirective = {
  key: ConditionDirectiveKeys
  values?: string[]
}
export type ConditionsRule = {
  id: string
  name: string
  booleanOperator: ConditionBooleanOperators
  conditionSets: ConditionSet[]
  directive: ConditionDirective
}

export type ConditionError = {
  fieldId: string
  ruleId: string
  setIndex: number
  linkedFieldId?: string
  value?: string
}

export enum ConditionFieldType {
  input = 'INPUT',
  select = 'SELECT'
}

export type ConditionalFieldWithRules = {
  id: string
  rules: ConditionsRule[]
  fieldState?: ConditionDirectiveKeys // directive based on field validation, calculated in runtime
}
export type ConditionalFieldOption = {
  id: string
  value: string
  selected?: boolean
  showTextField?: boolean
  optionId?: string
  text?: string
}

export type ConditionalFieldData = {
  id: string
  fieldName?: string // title/label of a question
  sectionName?: string // title/label of a section
  fieldNameKey?: string // predefined title/label of a question in case if it cannot be modified by user
  sectionNameKey?: string // section name
  values: Array<string | boolean | number> // inputted values by user
  type: ConditionFieldType // input/select type
  rules?: ConditionsRule[]
  options?: ConditionalFieldOption[] // for select type only
  data?: any
}
